import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
  pipelines: [],
  cards: [],
  activePipelineId: null,
  activeFilters: { status: ['open', 'won', 'lost'] },
  uiFlags: {
    isLoadingPipelines: false,
    isLoadingCards: false,
    loadError: null,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
